import { projectManagementApi } from '@/includes/projectManagementApi';

const pmDecisionService = {
  async listDecisions(projectId) {
    const response = await projectManagementApi.get(`/projects/${projectId}/decisions`);
    return response.data;
  },

  async getDecision(projectId, id) {
    const response = await projectManagementApi.get(`/projects/${projectId}/decisions/${id}`);
    return response.data;
  },

  async createDecision(projectId, payload) {
    const response = await projectManagementApi.post(
      `/projects/${projectId}/decisions`,
      payload,
    );
    return response.data;
  },

  async updateDecision(projectId, id, payload) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/decisions/${id}`,
      payload,
    );
    return response.data;
  },

  async deleteDecision(projectId, id) {
    const response = await projectManagementApi.delete(
      `/projects/${projectId}/decisions/${id}`,
    );
    return response.data;
  },

  async updateStatus(projectId, id, status) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/decisions/${id}/status`,
      { status },
    );
    return response.data;
  },

  async escalateDecision(projectId, id) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/decisions/${id}/escalate`,
    );
    return response.data;
  },
};

export default pmDecisionService;
